import { createPlugin } from '@backstage/core-plugin-api';

export const azureSubscriptionPickerPlugin = createPlugin({
  id: 'azure-subscription-picker',
});
